import { ThemeUICSSObject } from 'theme-ui';
import { focusOutline } from '../../util';
import getColorsAndStatesByPath from '../colors/util/getColorsAndStatesByPath';

const deletableInput: ThemeUICSSObject = {
  border: '1px solid',
  borderColor: 'palette.border.field',
  display: 'inline-block',
  position: 'relative',
  pr: '45px',

  '.deletableInput__input': {
    border: 'none',
  },

  '.deletableInput__deleteButton': {
    height: '80%',
    outlineOffset: '-2px',
    position: 'absolute',
    right: 0,
    top: 0,
    width: '40px',

    ...getColorsAndStatesByPath('buttons.deletableInputButton', {
      states: { path: true },
    }),
  },

  '&:focus-within:not(.asMaterial)': {
    ...focusOutline,

    '.deletableInput__input:focus': {
      outline: 'none',
    },

    '.deletableInput__deleteButton:focus': {
      outline: 'none',
    },
  },

  '&.asMaterial': {
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: 'none',
    borderBottomColor: 'palette.border.section',

    '& + .input__underline': {
      transform: 'scale(1)',
    },

    '.deletableInput__input:focus': {
      outline: 'none',

      '~.input__underline::after': {
        animationName: 'growHorizontal',
        animationDuration: '150ms',
        animationTimingFunction: 'ease-out',
        content: '""',
        display: 'block',
        height: '0',
        outlineColor: 'palette.primary.main',
        outlineStyle: 'solid',
        outlineWidth: '1.5px',
        outlineOffset: 0,
        position: 'absolute',
        transformOrigin: 'center center',
        left: 0,
        right: 0,
      },
    },
  },
};

export default deletableInput;
